import React from "react";
import useAuthenticatedMedia from "../../hooks/useAuthenticatedMedia";

const AuthenticatedVideo = ({ url, ...props }) => {
  const mediaUrl = useAuthenticatedMedia(url);
  return <video {...props} src={mediaUrl || undefined} />;
};

export default AuthenticatedVideo;
